export default __webpack_public_path__ + "static/ITCAvantGardeStd-Bk-01dbf87cf32f470d63ab8c53ce131f86.woff2";